import { CalculationEngineMonthlyValueOverrides, FarmerMarginCalculatorModel, RunCalculationEngineResponse } from '../../../../../../Generated/Raven-Demeter';
import TextInput from '../../../../../Components/Form/Inputs/TextInput';
import RegexValidators from '../../../../../Core/Validation/RegexValidators';
import formattingService from '../../../../../Services/Formatting/FormattingService';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../../../Services/Tracking/TrackingService';
import { DemeterCalculationEngineLineShortModelWithChildren, HideGroup, MarginCompositeModel, TabEventKeyType } from '../../../RiskDefinitions';
import MarginInputRow from '../MarginInputRow';
import styles from '../MarginInputsTable.module.scss';

interface IMarginInputsTableProductionLotLinesDataProps {
    getFarmerMarginCalculatorCompositeRowsModel: MarginCompositeModel[];
    runCalculationEngineResponse: RunCalculationEngineResponse;
    savedFarmerMarginCalculator?: FarmerMarginCalculatorModel;
    runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null;
    setRunMonthlyValueOverrides: (runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null) => void;
    hideGroup: HideGroup;
    handleGridTabNavigation: (columnIndex: number, rowIndex: number, direction: TabEventKeyType) => void;
    handleRemoveLotLineRow: (row: DemeterCalculationEngineLineShortModelWithChildren) => void;
    track: TrackingEvent;
}

const MarginInputsTableProductionLotLinesData: React.FC<IMarginInputsTableProductionLotLinesDataProps> = (
    props: IMarginInputsTableProductionLotLinesDataProps,
) => {
    const [translations] = useLanguage();

    const firstRowModel = props.getFarmerMarginCalculatorCompositeRowsModel[0];
    const topLevelBackground = styles.margin_inputs_table_level_1_background;
    const showProductionLotLinesChildren = props.hideGroup.totalProductionQuantity === false;
    const rowChildren = (firstRowModel.productionLines[0] as DemeterCalculationEngineLineShortModelWithChildren)?.children;

    if (!rowChildren || !showProductionLotLinesChildren) {
        return null;
    }

    return (
        <>
            {rowChildren.map((x) => {
                if (x.variableName?.includes('lot')) {
                    return (
                        <div key={x.variableName} className={styles.margin_inputs_table_lot_name_area}>
                            <div className={styles.margin_inputs_table_lot_name}>
                                <TextInput
                                    className={styles.risk_input}
                                    value={
                                        props.runMonthlyValueOverrides![0]?.textOverrides
                                            ? props.runMonthlyValueOverrides![0]?.textOverrides[x.variableName]
                                            : ''
                                    }
                                    validation={RegexValidators.AlphaNumericMinimumLength2}
                                    handleTextChange={(value) => {
                                        const asOfDate = props.getFarmerMarginCalculatorCompositeRowsModel[0].asOfDate!;

                                        const newRequest = [
                                            ...props.runMonthlyValueOverrides!.map((y) => ({
                                                ...y,
                                                textOverrides: { ...y.textOverrides, [x.variableName]: value },
                                            })),
                                        ];

                                        if (props.runMonthlyValueOverrides?.length === 0 || !props.runMonthlyValueOverrides) {
                                            newRequest.push({
                                                asOfDate: formattingService.toApiDate(new Date(asOfDate).toISOString()),
                                                valueOverrides: {},
                                                textOverrides: { [x.variableName]: value },
                                            });
                                        }

                                        props.setRunMonthlyValueOverrides(newRequest);
                                    }}
                                    track={{
                                        eventCategory: 'MarginCalculator',
                                        eventAction: 'LotLineChanged',
                                        eventValue: props.runMonthlyValueOverrides![0]?.textOverrides
                                            ? props.runMonthlyValueOverrides![0]?.textOverrides[x.variableName]
                                            : '',
                                    }}
                                />
                            </div>
                            <button className={styles.margin_inputs_table_remove_lot} type="button" onClick={() => props.handleRemoveLotLineRow(x)}>
                                {translations.actions.remove}
                            </button>
                        </div>
                    );
                }

                if (x.rowElement) {
                    return x.rowElement;
                }

                return (
                    <MarginInputRow
                        key={x.variableName}
                        className={topLevelBackground}
                        getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                        hideGroup={props.hideGroup}
                        runCalculationEngineResponse={props.runCalculationEngineResponse}
                        fieldName={x.variableName}
                        handleGridTabNavigation={props.handleGridTabNavigation}
                        runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                        setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                        savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                        track={{ ...props.track, eventAction: `${props.track.eventAction}` }}
                    />
                );
            })}
        </>
    );
};

export default MarginInputsTableProductionLotLinesData;
